import { FormBase } from "@models/portal/users/form-base";
import { MetadataPutEnum } from "@models/enums/metadata-put-enum";
import { Utils } from "src/app/core/utilities/utils";
import { IScoreTemplateWoDto } from "../dtos/wo-scoreboard-template-dto";

export class ScoreTemplateWoPostForm extends FormBase {
    ptwNrPeriodo?: number;
    ptwTxPeriodo?: string;
    ptwBlVencedor?: boolean;
    ptwNrPlacar?: number;
    ettNrId?: number;

    constructor() {
        super();
    }

    public static createFromDto(data: IScoreTemplateWoDto): ScoreTemplateWoPostForm {
        const form = new ScoreTemplateWoPostForm();
        form.ptwNrPeriodo = data.ptwNrPeriodo;
        form.ptwTxPeriodo = data.ptwTxPeriodo;
        form.ptwBlVencedor = data.ptwBlVencedor;
        form.ptwNrPlacar = data.ptwNrPlacar;
        form.ettNrId = data.ettNrId;
        form.entNrId = data.ptwNrId;
        form.entTxMetadado = MetadataPutEnum.INALTERADO;
        return form;
    }

    static of(form: Partial<ScoreTemplateWoPostForm>): ScoreTemplateWoPostForm {
        const newForm = new ScoreTemplateWoPostForm();
        Object.assign(newForm, form);
        newForm.entTxMetadado = form.entTxMetadado ?? MetadataPutEnum.CRIADO;
        return newForm;
    }

    verifyChanges(currentState?: IScoreTemplateWoDto): void {
        if (!currentState || !Utils.isDefinedAndNotNull(currentState.ptwNrId)) {
            this.entTxMetadado = MetadataPutEnum.CRIADO;
            return;
        }

        let modified = false;
        if (this.ptwNrPeriodo !== currentState.ptwNrPeriodo) modified = true;
        if (this.ptwTxPeriodo !== currentState.ptwTxPeriodo) modified = true;
        if (this.ptwBlVencedor !== currentState.ptwBlVencedor) modified = true;
        if (this.ptwNrPlacar !== currentState.ptwNrPlacar) modified = true;
        if (this.ettNrId !== currentState.ettNrId) modified = true;

        this.entTxMetadado = modified ? MetadataPutEnum.ALTERADO : MetadataPutEnum.INALTERADO;
    }

    static buildPutForm(newState: ScoreTemplateWoPostForm, currentState?: IScoreTemplateWoDto): ScoreTemplateWoPostForm {
        const updatedForm = new ScoreTemplateWoPostForm();
        Object.assign(updatedForm, newState);
        updatedForm.entNrId = currentState?.ptwNrId ?? newState.entNrId;

        let modified = false;
        if (newState.ptwNrPeriodo !== currentState?.ptwNrPeriodo) modified = true;
        if (newState.ptwTxPeriodo !== currentState?.ptwTxPeriodo) modified = true;
        if (newState.ptwBlVencedor !== currentState?.ptwBlVencedor) modified = true;
        if (newState.ptwNrPlacar !== currentState?.ptwNrPlacar) modified = true;
        if (newState.ettNrId !== currentState?.ettNrId) modified = true;

        updatedForm.entTxMetadado = modified ? MetadataPutEnum.ALTERADO : MetadataPutEnum.INALTERADO;
        return updatedForm;
    }

    static markAsDeleted(templateId: number, wasDeleted: boolean): ScoreTemplateWoPostForm {
        const deleted = new ScoreTemplateWoPostForm();
        deleted.entNrId = templateId;
        deleted.entTxMetadado = wasDeleted ? MetadataPutEnum.DELETADO : MetadataPutEnum.INALTERADO;
        return deleted;
    }
}
